import React, { useContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Ranking from "../Core/RankingsPage.jsx";
import RedirectPage from "./RankingRedirectPage.jsx";
import GameListSwitcherContainer from "../GamesMenu/GameListSwitcherContainer";
import FreeGameAdContainer from '../FreeGameAd/FreeGameAdContainer';
import { IsMobileContext } from "../isMobileContext";
import { getParams } from "../utils/common";
import GamesMenuContainer from "../GamesMenu/GamesMenuContainer";
import { SET_MOBILE_DETAILS_VIEW } from "../Core/Actions/mobileActions";

function RankingPageMobile({loading, current, redirectUrl, links, page}) {
    const dispatch = useDispatch();

    const mobile = useSelector(state => state.mobile);
    const game = useSelector(state => state.games.current);

    const toggleGameDetails = () => {

        // patch if user is comming from calendar and clicks to go back goto
        const params = getParams(window.location.href);
        if(params && params.from && params.from === "calendar" && mobile.gameDetailsVisible){
            window.history.go(-1)
            return;
        }

        dispatch({
            type: SET_MOBILE_DETAILS_VIEW,
            payload: {
                gameDetailsVisible: !mobile.gameDetailsVisible
            }
        });

        // reset marked sportsmen so that when we open game and marked was already set it will scroll down!
        dispatch({
            type: 'RESET_MARKED_SPORTSMEN'
        });
    }

    useEffect(()=>{
        // if user is coming from calendar we should not show it the game menu
        // instead show the results
        const params = getParams(window.location.href);
        if(params && params.from && params.from === "calendar"){
            toggleGameDetails();
        }
    },[])

    return(
        <div className="rankings rankings-mobile">
            {
                mobile && mobile.gameDetailsVisible ? (
                    <>
                        <div onClick={toggleGameDetails} className="results-details-close">
                            {game && game.name ? game.name : null}
                        </div>
                        {page}
                    </>
                ) : (<>
                    <GameListSwitcherContainer />
                    <GamesMenuContainer />
                </>)
            }
        </div>
    )
}

function RankingPage({loading, current, redirectUrl, links}) {

    const ctx = useContext(IsMobileContext);
    const user = useSelector(state => state.user);

    let page;
    if (current && redirectUrl) {
        page = <RedirectPage current={current} redirectUrl={redirectUrl}/>
    } else {
        page = <Ranking
            current={current}
            links={links}
            loading={loading}
        />;
    }

    if(ctx.isMobile){
        return <RankingPageMobile
            loading={loading}
            current={current}
            redirectUrl={redirectUrl}
            links={links}
            page={page}
        />
    }

    return <div className={`rankings${user.permissionLevel >= 4 ? ' rankings-admin' : ''}`}>
        <GameListSwitcherContainer/>
        <FreeGameAdContainer/>
        {page}
    </div>;

}

export default RankingPage